module.exports = __webpack_public_path__ + "img/weffwfeffefe.df426c35.png";